import { useCallback } from 'react';
import useLocale from '@/common/hooks/useLocale';

const useLocalizedField = () => {
  const { isFr } = useLocale();

  return useCallback(
    (item, key) => {
      if (!item || !key) return undefined;
      if (!isFr) return item[key];

      const frKey = `${key}Fr`;
      return item[frKey] || item[key];
    },
    [isFr]
  );
};

export default useLocalizedField;
